export default {
  add_items: 'Artikel hinzufügen',
  remove_items: 'Artikel entfernen',
  place_order: 'Bestellung aufgeben',
  proceed_to_payment: 'Weiter zur Zahlung',
  go_to_menu: 'Zum Menü gehen',

  toasts: {
    input_errors_found: 'Es gibt einige Probleme mit den Bestelldaten',
  },

  error_messages: {
    internal_error: {
      title: 'Bestellung erfolglos 😔',
      description:
        'Leider gab es ein unerwartetes Problem mit deiner Bestellung, unser technisches Team arbeitet bereits daran 🛠️.',
    },
  },
};
